<template>
  <h1 class="text-secondary">Pagina op eportal/orderportaal niet gevonden</h1>
</template>

<script>
export default {
  name: "NotFoundPage",
}
</script>